import React, { /*useState*/ } from 'react'

// Deps
// import { connect } from 'react-redux'

// Partials
import Btn from 'views/shared/partials/btn'
import Image from 'views/shared/partials/image'
import Pricebox from 'views/shared/partials/pricebox'
// import Collapser from 'views/shared/partials/collapser'

// Utils
// import { openModal } from 'utils/modals'

// functions
// import formatDate from 'functions/format-date'

// Services
// import orderServices from 'services/order'
// import commerceServices from 'services/commerce'

const ReturnOrderProductSummary = ({ refunds, productList, returnData, returnAmount, close, ...props}) => {
	return (
		<div
			className={props.className}>
			<div className="modal-header dark">
				<h1 className="header-title">İade Özeti</h1>
				{props.closeBtn}
			</div>

			<div className="modal-content">
				<p className="summary-title">İade Edilen Ürünler</p>

				<ul className="modal-group summary-products">
					{productList.map((product, nth) => (
						<li className="products-product" key={'summary-product-' + nth}>
							<div className="product-imagewrap">
								<Image src={product.product.image_link} lazy={false} className="product-image" />
							</div>
							<div className="product-text">
								<strong className="text-title">{product.product.title}</strong>
								<div className="text-reason">
									<strong className="reason-title">İade sebebi:</strong>
									<p className="reason-text">
										{product.refund_reason}
									</p>
								</div>
							</div>
							<Pricebox className="product-price" price={product.return_price} />
						</li>
					))}
				</ul>

				{(refunds && refunds.length !== 0) &&
					<>
						<p className="summary-title">Ödeme İadeleri</p>

						<ul className="modal-group summary-refunds">
							{refunds.map((refund, nth) => (
								<li className="refunds-refund" key={'summary-refund-' + nth}>
									<div className="refund-info">
										<p><strong>{refund.process.payment.card_masked}</strong></p>
										<p className="info-subtitle">{refund.process.payment.card_name}</p>
										<p className="info-subtitle">Onay kodu: {refund.process.payment.approve_code}</p>
									</div>

									<div className="refund-total">
										<p className="total-title">İade Tutarı:</p>
										<p>
											<Pricebox price={refund.process.refund_price} />
										</p>
										<p>
											{refund.success ?
												<span className="label success">Başarılı</span>
												:	
												<span className="label error">Başarısız</span>
											}
										</p>
									</div>
								</li>
							))}
						</ul>
					</>
				}


				<div className="modal-group wide summary-sum">
					<div className="sum-row">
						<strong>İade Edilen Ürünler Toplamı</strong>
						<Pricebox price={returnData.total} />
					</div>
					<div className="sum-row">
						<strong>İade Edilen Tutar</strong>
						<Pricebox warning={returnAmount !== 0} big price={returnAmount} />
					</div>
				</div>
			</div>

			<div className="modal-controls">
				<Btn
					onClick={close}>
					Tamam
				</Btn>
			</div>
		</div>
	)
}

ReturnOrderProductSummary.defaultProps = {
	className: '',
	containerClass: 'modal-return-order-product-summary mobile-full',
	name: 'return-order-product-summary',
}

export default ReturnOrderProductSummary